import * as React from 'react';

export interface HeadingProps {
  children: string;
}

/**
 * Converts inner HTML text into a formatted ID selector for on-page anchor tags
 */
export function getAnchor(text?: string | string[]): string {
  let t = Array.isArray(text) ? text.find((i) => typeof i === 'string') : text;
  if (!t) return '';
  return t
    .toLowerCase()
    .replace(/[^-a-z0-9 ]/g, '')
    .replace(/[ ]/g, '-');
}

export const H2 = ({ children }: HeadingProps) => {
  const anchor = getAnchor(children);
  return <h2 id={anchor}>{children}</h2>;
};

export const H3 = ({ children }: HeadingProps) => {
  const anchor = getAnchor(children);
  return <h3 id={anchor}>{children}</h3>;
};
